/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecruiteeConnectionSecrets interface.
 */
export function instanceOfRecruiteeConnectionSecrets(value) {
    if (!('apiKey' in value) || value['apiKey'] === undefined)
        return false;
    if (!('companyId' in value) || value['companyId'] === undefined)
        return false;
    if (!('webhookSecret' in value) || value['webhookSecret'] === undefined)
        return false;
    return true;
}
export function RecruiteeConnectionSecretsFromJSON(json) {
    return RecruiteeConnectionSecretsFromJSONTyped(json, false);
}
export function RecruiteeConnectionSecretsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'apiKey': json['apiKey'],
        'companyId': json['companyId'],
        'webhookSecret': json['webhookSecret'],
    };
}
export function RecruiteeConnectionSecretsToJSON(json) {
    return RecruiteeConnectionSecretsToJSONTyped(json, false);
}
export function RecruiteeConnectionSecretsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'apiKey': value['apiKey'],
        'companyId': value['companyId'],
        'webhookSecret': value['webhookSecret'],
    };
}
